'use strict';/* global define */define('modules/core/modules/utils/services/browser-mode/index',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
     factory.$inject = ["$window", "$rootScope", "LocalStorage"];
function factory($window,$rootScope,LocalStorage){// jshint validthis:true
// jshint latedef:false
var _isIncognito=false;_detectBrowserMode();return{isIncognito:isIncognito};// ---
/**
     * Determine, if the user browses incognito
     * the method uses a callback internally and sets _isBrowserInIncognitoMode asynchronously
     *
     * @private
     */function _detectBrowserMode(){var fs=$window.RequestFileSystem||$window.webkitRequestFileSystem;if(!fs){return;}fs($window.TEMPORARY,100,function(){},function(){_isIncognito=true;$rootScope.$digest();});}/**
     * Gets the browser mode
     *
     * @return {boolean} - Browser mode
     */function isIncognito(){return _isIncognito;}}module.exports=factory;});
